import React, { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import AddPriceModal from './AddPriceModal'; 
 

const SpecialPricing= ({ onRowsUpdate }) => {
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [rows, setRows] = useState([
    
     
  ]);
  const [modalVisible, setModalVisible] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [, ] = useState([]);
  const handleEdit = (id) => {

  };
  const handleDelete = (id) => {

    setRows(rows.filter(row => row.id !== id));
    setSelectedRowId(null);
  };

  const handleRowClick = (row) => {
    setSelectedRowId(row.id === selectedRowId ? null : row.id);
  };
  const handleModalSubmit = (newData) => {

    const updatedRows = [...rows, {
      price: newData.price,
      pricingFor: newData.pricingFor,
      group: newData.group,
      account: newData.account,
      procedure: newData.procedure
    }];
    setRows(updatedRows);
    onRowsUpdate(updatedRows); 
    setModalVisible(false);
  };
  const columns = [
    { field: 'price', headerName: 'Price', width: 200 },
    { field: 'group', headerName: 'Group', width: 250, align: 'center', headerAlign: 'center' },
    { field: 'account', headerName: 'Account', width: 250, align: 'center', headerAlign: 'center' },
    { field: 'procedure', headerName: 'Procedure', width: 250, align: 'center', headerAlign: 'center' },
  ];
  // const filteredRows = updatedRows.filter(row =>
  //   Object.values(row).some(value =>
  //     value.toString().toLowerCase().includes(searchTerm.toLowerCase())
  //   )
  // );
  return (
    <>
      <h2 className="title  mt-4" >Special Pricing</h2> 
          <div style={{backgroundColor:"#f4f4f4",padding:"10px",borderTop:"2px solid #004aad"}}>
          <div className="col-md-15 d-flex justify-content-end">
            <button type="button" className="btn btn-primary"style={{backgroundColor:"#004aad",borderColor:"#004aad"}} onClick={() => setModalVisible(true)}>
              Add price
            </button>
          </div>
      
        
      <AddPriceModal 
        modalVisible={modalVisible} 
        handleClose={() => setModalVisible(false)} 
  handleAddEntry={handleModalSubmit} 
      /> 
      <div style={{ height: 200, width: '100%', position: 'relative', marginTop: '2%', background:'#f0f0f5' }}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={5}
          getRowId={(row) => `${row.price}-${row.pricingFor}`} // Custom ID generator
          onRowClick={(params) => handleRowClick(params.row)}
          components={{
            Toolbar: () => null,
          }}
          sx={{
            '& .MuiDataGrid-columnHeaderTitle': {
              fontWeight: 'bold',
            }, 
            '& .MuiDataGrid-cell:focus': {
              outline: 'none',  
            },
            '& .MuiDataGrid-cell:focus-within': {
              outline: 'none',  
            },
          }}
        />
        {selectedRowId !== null && (
          <div
            style={{
              position: 'absolute',
              top: rows.findIndex(row => row.id === selectedRowId) * 52 + 48,
              right: '10px',
              display: 'flex',
              marginTop: '15px'
            }}
          >
            <button
              style={{
                padding: '8px 16px',
                backgroundColor: '#0d6efd',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                marginRight: '5px',
              }}
              onClick={() => handleEdit(selectedRowId)}
            >
              Edit
            </button>
            <button
              style={{
                padding: '8px 16px',
                backgroundColor: '#0d6efd',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
              onClick={() => handleDelete(selectedRowId)}
            >
              Delete
            </button>
          </div>
        )}
      </div>
      </div>
    </>
  );
};
export default SpecialPricing;
